import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
class LedgerTypesService {

  create = async (transaction: any) => {
    const res = await axios({
      method: "post",
      url: `${API_URL}ledger-type`,
      data: transaction,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
    return res.data;
  };

  // edit = async (transaction: any, code: any) => {
  //   await axios({
  //     method: "put",
  //     url: `${API_URL}account-transaction/${code}`,
  //     data: transaction,
  //   }).catch((e) => {
  //     // const { message } = e.response.data;
  //     // if (message.errorInfo) throw message.errorInfo[2];
  //     // else throw e.message;
  //     throw e;
  //   });
  // };

  get = async (code: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}ledger-type/${code}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.ledgerType;
  };

  getAll = async () => {
    const response = await axios({
      method: "get",
      url: `${API_URL}ledger-type`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.ledgerTypes;
  };

  search = async (keyword: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}ledger-type-search/${keyword}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.ledgerTypes;
  };





}
export default new LedgerTypesService();
